import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Mail, Phone, Building } from 'lucide-react';
import AdminLayout from './AdminLayout';
import { api } from '../../lib/api';
import { fmtDate, StatusBadge } from '../../lib/format';

export default function AdminClientDetailPage() {
  const { id } = useParams();
  const [client, setClient] = useState(null);
  useEffect(() => { api.adminClient(id).then(setClient); }, [id]);
  if (!client) return <AdminLayout title="Client"><div className="text-neutral-400">Loading…</div></AdminLayout>;
  return (
    <AdminLayout title={`${client.first_name} ${client.last_name}`} subtitle={client.email}
      actions={<Link to="/admin/clients" className="inline-flex items-center gap-1.5 text-[13px] text-neutral-500 hover:text-[#c89200]"><ArrowLeft className="w-4 h-4" /> Back</Link>}
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="rounded-xl bg-white border border-neutral-100 p-6">
          <h3 className="text-[17px] font-bold text-[#14110f] mb-4">Profile</h3>
          <div className="space-y-3 text-[13.5px]">
            <p className="flex items-center gap-2.5"><Mail className="w-4 h-4 text-[#c89200]" /> {client.email}</p>
            {client.phone && <p className="flex items-center gap-2.5"><Phone className="w-4 h-4 text-[#c89200]" /> {client.phone}</p>}
            {client.company && <p className="flex items-center gap-2.5"><Building className="w-4 h-4 text-[#c89200]" /> {client.company}</p>}
            <p className="text-[12px] text-neutral-400">Client since {fmtDate(client.created_at)}</p>
          </div>
        </div>
        <div className="lg:col-span-2 rounded-xl bg-white border border-neutral-100 p-6">
          <h3 className="text-[17px] font-bold text-[#14110f] mb-4">Appointment history</h3>
          {(!client.appointments || client.appointments.length === 0) && <p className="text-[13px] text-neutral-400">No appointments yet.</p>}
          <ul className="divide-y divide-neutral-100">
            {(client.appointments || []).map((a) => (
              <li key={a.id} className="py-3 flex items-center justify-between">
                <div>
                  <Link to={`/admin/appointments/${a.id}`} className="font-medium text-[#14110f] hover:text-[#c89200] text-[14px]">{a.appointment_type_name}</Link>
                  <p className="text-[12px] text-neutral-500">{fmtDate(a.start)}</p>
                </div>
                <StatusBadge status={a.status} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </AdminLayout>
  );
}
